import api from './api';

const getPartners = () => {
  return api.get('/corporates/fetch');
};

export { getPartners };
